import Reference from "../../../extensions/reference";
import {createMarkdownExtension} from "../../util/extensions";

export  default createMarkdownExtension(Reference, {
  serialize(state, node) {
    state.write(node.attrs.originalText || node.attrs.text);
  },
  parse: {
    setup() {

    },
    updateDOM(element) {

    },
  }
})
